import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom'
import { Table, Button, Pagination, Form } from 'react-bootstrap';

const UserTable = ({ users }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    id: '',
    name: '',
    mobile: '',
    user_type: '',
    bucket: '',
    is_active: '',
    is_blocked: '',
  });

  const normalizedUsers = Array.isArray(users) ? users : (users ? [users] : []);

  const handleFilterChange = (key, value) => {
    setCurrentPage(1);
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  /* ---------- FILTER LOGIC ---------- */
  const filteredUsers = useMemo(() => {
    return normalizedUsers.filter(user => {
      const isActive = Boolean(user?.is_active);    // defaults to false
      const isBlocked = Boolean(user?.is_blocked);  // defaults to false
  
      return (
        (!filters.id || String(user?.id).includes(filters.id)) &&
        (!filters.name || user?.name?.toLowerCase().includes(filters.name.toLowerCase())) &&
        (!filters.mobile || user?.mobile?.includes(filters.mobile)) &&
        (!filters.user_type || user?.user_type?.toLowerCase().includes(filters.user_type.toLowerCase())) &&
        (!filters.bucket || user?.buckets?.[0]?.name?.toLowerCase().includes(filters.bucket.toLowerCase())) &&
        (filters.is_active === '' || String(isActive) === filters.is_active) &&
        (filters.is_blocked === '' || String(isBlocked) === filters.is_blocked)
      );
    });
  }, [normalizedUsers, filters]);
  

  /* ---------- PAGINATION ---------- */
  const indexOfLastUsers = currentPage * usersPerPage;
  const indexOfFirstUsers = indexOfLastUsers - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUsers, indexOfLastUsers);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const handleEdit = (user) => {
    navigate(`/home/user-edit/${user.id}`, { state: { user_data: user } });
  };

  return (
    <>
      <Table striped bordered hover responsive className="bg-white">
        <thead className="bg-light">
          <tr>
            <th>
              User ID
            </th>

            <th>
              Name
              <Form.Control
                size="sm"
                placeholder="Filter"
                value={filters.name}
                onChange={e => handleFilterChange('name', e.target.value)}
              />
            </th>

            <th>
              Contact
            </th>

            <th>
              User Type
              <Form.Control
                size="sm"
                placeholder="Filter"
                value={filters.user_type}
                onChange={e => handleFilterChange('user_type', e.target.value)}
              />
            </th>

            <th>Assigned Lead Count</th>

            {/* <th>
              Bucket
            </th> */}

            <th>
              Active
              <Form.Select
                size="sm"
                value={filters.is_active}
                onChange={e => handleFilterChange('is_active', e.target.value)}
              >
                <option value="">All</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </Form.Select>
            </th>

            <th>
              Blocked
              <Form.Select
                size="sm"
                value={filters.is_blocked}
                onChange={e => handleFilterChange('is_blocked', e.target.value)}
              >
                <option value="">All</option>
                <option value="true">Blocked</option>
                <option value="false">Not Blocked</option>
              </Form.Select>
            </th>

            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {currentUsers.length > 0 ? (
            currentUsers.map((user, index) => (
              <tr key={index}>
                <td>{user?.id}</td>
                <td>
                  <p className="fw-bold mb-1">{user?.name}</p>
                  <p className="text-muted mb-0">{user?.email}</p>
                </td>
                <td>{user?.mobile}</td>
                <td>{user?.user_type}</td>
                <td>{user?.lead_count}</td>
                {/* <td>{user?.buckets?.[0]?.name ?? 'No Bucket'}</td> */}
                <td>{user?.is_active ? 'Active' : 'Inactive'}</td>
                <td>{user?.is_blocked ? 'Blocked' : 'Not Blocked'}</td>
                <td>
                  <Button variant="link" size="sm" onClick={() => handleEdit(user)}>
                    Edit
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center text-muted">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Pagination className="justify-content-center mt-3">
        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i + 1}
            active={i + 1 === currentPage}
            onClick={() => setCurrentPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </>
  );
};

export default UserTable;
